/**
 * @generated SignedSource<<1336441ff66e1c5f44c88192e9d08910>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ResendGiftCardInput = {
  giftCardId: string;
};
export type TransactionItemResendGiftCardMutation$variables = {
  input: ResendGiftCardInput;
};
export type TransactionItemResendGiftCardMutation$data = {
  readonly resendGiftCard: {
    readonly successful: boolean;
    readonly message: string;
  } | null;
};
export type TransactionItemResendGiftCardMutation = {
  variables: TransactionItemResendGiftCardMutation$variables;
  response: TransactionItemResendGiftCardMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CashoutResponse",
    "kind": "LinkedField",
    "name": "resendGiftCard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "successful",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TransactionItemResendGiftCardMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TransactionItemResendGiftCardMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cc88c938b5617ded8be9399b8323ac96",
    "id": null,
    "metadata": {},
    "name": "TransactionItemResendGiftCardMutation",
    "operationKind": "mutation",
    "text": "mutation TransactionItemResendGiftCardMutation(\n  $input: ResendGiftCardInput!\n) {\n  resendGiftCard(input: $input) {\n    successful\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "fbf42567fc7a6769d444ee5b4662a0ae";

export default node;
